class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');
    
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    var optionname = jQuery('#CartItem-'+line).attr('variant-option-name');
    var variantname = jQuery('#CartItem-'+line).attr('variant-name');
    var data_io_parent_group_id = jQuery('#CartItem-'+line).attr('data-io-parent-group-id');

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();

        
        setTimeout(function () {
          
          //var lineidex = line;
          //console.log(data_io_parent_group_id);
          var mainproductlineid = jQuery('.cart-item[data-io-group-id="'+data_io_parent_group_id+'"]').attr('id');
          var mainproductline = '';
          if(mainproductlineid){
            var mainproductlineArr = mainproductlineid.split('-');
            var mainproductline = mainproductlineArr[1];
          }
  
          //var mainproductline = jQuery('.cart-item[data-io-group-id="'+data_io_parent_group_id+'"]').index();
    
          //console.log(mainproductline);
          //console.log(optionname);
          if(data_io_parent_group_id && optionname && mainproductlineid){
            jQuery.getJSON('/cart.js', function(cart) {
              var items = cart.items;
            
              var newIndex = mainproductline;
              // if(mainproductline){
              //   var newIndex = mainproductline;
              // }else{
              //   var newIndex = lineidex;
              // }
            
              var properties = items[newIndex-1].properties;
              
    
              
              //console.log(properties);

              if(optionname == 'Metallic Gold Number Candles'){
                //properties['Macaron Gift Box_Options'] = '';
                
                if(properties['Numbered Candles_1'] == variantname){
                  delete properties['Numbered Candles_1'];
                }
                if(properties['Numbered Candles_2'] == variantname){
                  delete properties['Numbered Candles_2'];
                }
                if(properties['Numbered Candles_3'] == variantname){
                  delete properties['Numbered Candles_3'];
                }

                if(!properties['Numbered Candles_1'] && !properties['Numbered Candles_2'] && !properties['Numbered Candles_3']){
                  delete properties['Candles & Sparklers'];
                  delete properties['Number_Candle_Select'];
                  delete properties['Numbered_Candle_Option'];
                }
                
              }
    
              if(optionname == 'Cake Topper'){
                //properties['Cake Topper Option'] = '';
                delete properties['Cake Topper_options'];
                delete properties['Cake Topper Option'];
              }
              if(optionname == 'Candles'){
                //properties['Candles_Options'] = '';
                delete properties['Candles_Options'];
                delete properties['Candles'];
              }
              if(optionname == 'Balloons'){
                //properties['Balloons_Options'] = '';
                delete properties['Balloons_Options'];
              }
              if(optionname == '250gs_coffee'){
                //properties['Balloons_Options'] = '';
                delete properties['250gs_coffee'];
                delete properties['Coffee_Options'];
              }
              if(optionname == 'Christmas Fondant Fancies'){
                //properties['Balloons_Options'] = '';
                delete properties['Fondant Fancies'];
                delete properties['Fondant Fancy Options'];
              }
              if(optionname == 'Handwritten Card'){
                delete properties['Handwritten Card (£4.95)'];
                delete properties['Handwritten Card Text'];
                delete properties['Card'];
                delete properties['Card option'];
                delete properties['Card message'];
              }
              if(optionname == 'Sparkler Fountains (£7.95)'){
                delete properties['Sparkler Fountains (£7.95)'];
                delete properties['Sparkler_Options'];
              }
              if(optionname == 'Mince Pies'){
                delete properties['Mince Pie Option'];
              }
              if(optionname == 'Inscription'){
                //properties['Inscription (£5.95)'] = '';
                //properties['Inscription Text'] = '';
                delete properties['Inscription (£5.95)'];
                delete properties['Inscription Text'];
              }
              if(optionname == '12 Macaron Gift Box (£15.95)'){
                //properties['Macaron Gift Box_Options'] = '';
                delete properties['Macarons'];
                delete properties['Macaron Gift Box_Options'];
              }
              
              delete properties[optionname];
    
              jQuery.ajax({
                 url : '/cart/change.js',
                 data : {line: newIndex, properties: properties},
                 dataType: 'json',
                 success: function(res){
                   location.reload();
                 }
              });
            
          });
        }else{
            location.reload();
        }
        }, 2000);

      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });

      //var addon_row = $remove.closest('.cart__items');
      
      
      localStorage.removeItem("DeliveryDateNew");

      
    
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};
